import { render, staticRenderFns } from "./WhyBerza.vue?vue&type=template&id=0ccbb8b6&scoped=true&"
import script from "./WhyBerza.vue?vue&type=script&lang=js&"
export * from "./WhyBerza.vue?vue&type=script&lang=js&"
import style0 from "./WhyBerza.vue?vue&type=style&index=0&id=0ccbb8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbb8b6",
  null
  
)

export default component.exports